import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Bug, Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="container nav-content">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          
          <span>Odonata Boy</span>
        </NavLink>

        <div className="nav-desktop">
          <NavLink to="/" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Home</NavLink>
          <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Observations</NavLink>
          <NavLink to="/about-odonata" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>About Odonata</NavLink>
          <NavLink to="/about-me" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>About Me</NavLink>
        </div>

        <button className="nav-mobile-toggle" onClick={toggleMenu}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        <div className={`nav-mobile-overlay ${isOpen ? 'active' : ''}`} onClick={closeMenu}></div>
        <div className={`nav-mobile-drawer ${isOpen ? 'active' : ''}`}>
          <div className="drawer-header">
            <button className="drawer-close" onClick={closeMenu}>
              <X size={28} />
            </button>
          </div>
          <div className="drawer-links">
            <NavLink to="/" className="drawer-link" onClick={closeMenu}>Home</NavLink>
            <NavLink to="/dashboard" className="drawer-link" onClick={closeMenu}>Observations</NavLink>
            <NavLink to="/about-odonata" className="drawer-link" onClick={closeMenu}>About Odonata</NavLink>
            <NavLink to="/about-me" className="drawer-link" onClick={closeMenu}>About Me</NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
